import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { catchError, tap, switchMap } from 'rxjs/operators';
import { Voucher } from '../shared/models/Voucher';
import { VOUCHER_URL } from '../shared/constats/urls';
import { TankService } from './tank.service';
import { Vehicle } from '../shared/models/Vehicle';

@Injectable({
  providedIn: 'root'
})
export class VoucherService {
  constructor(
    private http: HttpClient,
    private toastrService: ToastrService,
    private tankService: TankService
  ) { }

  private assignTankId(voucher: Voucher): Observable<Voucher> {
    return this.tankService.getCurrentTank().pipe(
      switchMap(tank => {
        voucher.tankId = tank.id;
        return this.http.post<Voucher>(VOUCHER_URL + '/', voucher);
      })
    );
  }

  saveVoucher(voucher: Voucher): Observable<any> {
    return this.http.post<Voucher>(VOUCHER_URL + '/', voucher).pipe(
      catchError((error) => {
        this.toastrService.error('Error al guardar el Cupon', 'Error');
        throw error;
      }),
      tap(() => {
        this.toastrService.success('Cupon guardado con éxito', 'Éxito');
      })
    );
  }

  /* editVoucher(id: string, voucher: Voucher): Observable<any> {
     return this.assignTankId(voucher).pipe(
       switchMap(() => this.http.put(VOUCHER_URL + '/' + voucher._id, voucher))
     );
   }*/

  editVoucher(id: Number, voucher: Voucher): Observable<any> {
    return this.http.put(VOUCHER_URL + '/' + id, voucher);
  }

  getAll(): Observable<Voucher[]> {
    return this.http.get<Voucher[]>(VOUCHER_URL);
  }

  getVoucher(id: Number): Observable<Voucher> {
    return this.http.get<Voucher>(VOUCHER_URL + '/' + id);
  }

  deleteVoucher(id: Number): Observable<any> {
    return this.http.delete(VOUCHER_URL + '/' + id);
  }

  getVoucherByTank(id: Number): Observable<Vehicle> {
    return this.http.get<any>(VOUCHER_URL + '/getVoucherByTank/' + id);
  }

  getVoucherByTankWithVehicle(id: Number): Observable<any> {
    return this.http.get<any>(VOUCHER_URL + '/getVoucherByTankWithVehicles/' + id);
  }
  
}
